export const FEATURE_NAME = '@zerops/zerops/feature/client-add-dialog';
